<div class="main-container lg-view">
	<div class="modal-overlay" [class.overlay]="isLoading"></div>
	<app-loader *ngIf="isLoading"></app-loader>
	<h3 *ngIf="!siteNote">{{(!isEditMode ? "Add" : "Edit")}} Note</h3>	
	<h5 *ngIf="siteNote">{{siteNote.siteName}}</h5>
	<h5 *ngIf="!siteNote">{{accountInfo?.accountSiteInfo?.name}}</h5>
	<div *ngIf="haveAccess == false" class="error">
		<p>You cannot {{(!isEditMode ? "add site notes" : "edit this site note")}} using the provided credentials</p>
	</div>
	<site-note-add-template #siteNoteAdd *ngIf="haveAccess"
		[siteNote]="siteNote"
		[jobId]="jobId"
		[isOnCompleteNote]="false"
		[possibleAssignees]="possibleAssignees"
		[accountSiteId]="accountSiteId"
		[assetTypes]="assetTypes"
		[locationTypes]="locationTypes"
		(onSiteNoteAddSave)="onSiteNoteAddSave($event)"
		(onSiteNoteEditSave)="onSiteNoteEditSave($event)"
		(onSaveButtonEnable)="enableSaveButton($event)"
	></site-note-add-template>
</div>
<div class="actions-container md-view" *ngIf="haveAccess">
	<ng-container>
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [clickAction]="onBackClick.bind(self)" [disabled]="isLoading"></action-button>
		<action-button [icon]="ButtonIcons.AddPhoto" [name]="'Photos'" [badge]="photosBadge" [clickAction]="onClickAddPhotos.bind(self)" [disabled]="isLoading"></action-button>
		<action-button [icon]="ButtonIcons.Save" [name]="'Save'" [clickAction]="onSaveClick.bind(self)" [disabled]="isLoading || !isSaveButtonEnabled"></action-button>
	</ng-container>
</div>

<site-note-photos [isVisible]="isAddPhotosVisible" (close)="onCloseAddPhotos($event)"></site-note-photos>

<generic-modal #submitConfirmationModal class="submit-confirmation-modal">
	<ng-template #modalHeading>
		<strong>Add Note Warning</strong>
	</ng-template>
	<ng-template #modalBody let-data="data">
		<div class="main-container">
			<div class="info-message">
				{{photosWarningMessage}}
			</div>
			<p>
				<strong>Are you sure you want to proceed?</strong>
			</p>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button mat-flat-button class="primary" (click)="onSaveConfirmed()" [disabled]="isLoading">Yes</button>
		<button mat-flat-button (click)="submitConfirmationModal.hide()" [disabled]="isLoading">No</button>
	</ng-template>
</generic-modal>